
export class ModalSetting {
  public static createLargeModal(initialState: any, customClass: String = ''): any {
    return Object.assign({ initialState }, { class: customClass + ' modal-component modal-dialog-centered modal-lg', ignoreBackdropClick: true });
  }

  public static createMediumModal(initialState: any, customClass: String = ''): any {
    return Object.assign({ initialState }, { class: customClass + ' modal-component modal-dialog-centered modal-m', ignoreBackdropClick: true });
  }

  public static createSmallModal(initialState: any, customClass: String = ''): any {
    return Object.assign({ initialState }, { class: customClass + ' modal-component modal-dialog-centered modal-sm', ignoreBackdropClick: true });
  }

  public static createDialog(initialState: any, customClass: String = ''): any {
    return Object.assign({ initialState }, { class: customClass + ' dialog-box modal-dialog-centered modal-sm', ignoreBackdropClick: true });
  }

  public static createMediumDialog(initialState: any, customClass: String = ''): any {
    return Object.assign({ initialState }, { class: customClass + ' dialog-box modal-dialog-centered modal-md', ignoreBackdropClick: true });
  }

  public static createLargeDialog(initialState: any, customClass: String = ''): any {
    return Object.assign({ initialState }, { class: customClass + ' dialog-box modal-dialog-centered modal-lg', ignoreBackdropClick: true });
  }

  public static unsavedChangesDialog(initialState: any, customClass: String = ''): any {
    return Object.assign({ initialState }, { class: customClass + ' dialog-box modal-dialog-centered modal-sm', ignoreBackdropClick: true });
  }
}
